<template lang="pug">
	
	#container
		
		.landing(ref="landing")
			background(ref='bg' v-if='!isTablet')
			header-element(v-if='!isTablet')
			scroll-indicator(v-if='!isTablet')
			menu-element(v-if='!isTablet')
			credits(v-if='!isTablet')
			
			.landing-container(ref="container")
				.desktop-version(v-if="$mq === 'desktop'")
					loader(ref='loader')
					intro(ref='intro').section
					presentation.section
					political.section
					youth(ref='youth').section
					pro-era(ref='proEra').section
					badass-origins(ref='B4Da$$').section
					amerikkkan(ref='ameriKKKan').section
					land-of-free(ref='landOfFree').section
					racism(ref='racism').section
					engagement(ref='engagement').section
					program(ref='').section

				mobile-version(v-if="$mq === 'tablet' || $mq === 'mobile'")

							
</template>

<script>
		
	import Vue from 'vue'
	import Component from 'vue-class-component'
	import $ from 'jquery'
	import { TweenMax } from 'gsap'
	import Scroller from './utils/scroller.js'
	import Globals from '~utils/Globals.js'
	import Loader from './components/loader.vue'
	import 'promise-polyfill/src/polyfill';

	import FontFaceObserver from 'fontfaceobserver'


	import Header from './partials/header.vue'
	import ScrollIndicator from './partials/scroll-indicator.vue'
	
	import Intro from './sections/intro.vue'
	import Presentation from './sections/presentation.vue'
	import Political from './sections/political/political.vue'
	import Youth from './sections/youth/youth.vue'
	import ProEra from './sections/pro-era/pro-era.vue'
	import BadassOrigins from './sections/badass-origins/badass-origins.vue'
	import Amerikkkan from './sections/amerikkkan/amerikkkan.vue'
	import LandOfFree from './sections/land-of-free/land-of-free.vue'
	import Racism from './sections/racism/racism.vue'
	import Engagement from './sections/engagement/engagement.vue'
	import Program from './sections/program/program.vue'
	
	import Background from './components/background.vue'
	import Menu from './partials/menu.vue'
	import Credits from './partials/credits.vue'
	import FlagsOverlay from './components/flags-overlay.vue'
	import MobileVersion from './sections/mobile-version.vue'

  @Component({
		name: 'App',
		components: { MobileVersion, FlagsOverlay, Loader, MenuElement : Menu,Credits, HeaderElement : Header, Intro, Presentation, Political,Youth,ProEra,BadassOrigins,Amerikkkan,LandOfFree,Racism,Engagement,Program, Background,ScrollIndicator  },
		data: function () {
			return {
				globals : Globals.state
			}
		},
		computed: {
			isMobile : function () {
				return this.globals.isMobile
			},
			isTablet : function () {
				return this.globals.isTablet
			}
		}
	})

	class App extends Vue {

		mounted () {

			if(!this.isTablet) {
				TweenMax.set(this.$refs.container,{y:window.innerHeight})
			}
			$(window).on('load', this.init);
			$(window).on('resize', _.throttle(this._resize.bind(this), 100));
			this.goTo = this.goTo.bind(this)
		}

		init () {
			let scrollHeight = this.$refs.container.getBoundingClientRect().height;
			
			if(!this.isTablet) {
				this.$container = this.$el.querySelector('.landing-container')

				this.scroller = new Scroller({
					el: this.$refs.container,
					ease: (window.innerWidth < 641) ? .2 : .1
				});
				
				this.scroller.pause()
				this.$events.on('app.loaded', this.loaded.bind(this))
				this.$events.on('app.anchor', this.goTo)

				let fontA = new FontFaceObserver('Saira Extra Condensed');
				let fontB = new FontFaceObserver('Poppins');
				let fontC = new FontFaceObserver('Abhaya Libre');

				Promise.all([fontA.load(), fontB.load(), fontC.load()]).then((fonts) => {

					this.$refs.bg.animateIn()
					// this.$events.emit('app.loaded')
					this.$refs.loader.load()
				}).catch(function () {
					this.$refs.bg.animateIn()
					this.$events.emit('app.loaded')
					this.$refs.loader.load()
					// console.log('Fonts didnt load.');
				});
							
			} else {
				this.$container = this.$el.querySelector('.landing-container')

				this.scroller = new Scroller({
					el: this.$refs.container,
					ease: (window.innerWidth < 641) ? .2 : .1
				});
				this.$events.emit('app.loaded')
				this.scroller.pause()
			}

			
		}

		goTo (target) {
			const to = this.$refs[target]
			if(to) {
				const h = this.scroller.height
				const top = to.bounds.top
				const ratio = (top / h)
				this.scroller.to(top,ratio * 1000)
			}

		}

		loaded () {
			
			this.tl = new TimelineMax({onComplete:()=>{
				this.scroller.play()
				Globals.isLoaded = true
				this._resize()
				this.$events.emit('scroll.in')
			}})
			this.tl.to(this.$refs.container,2,{y:0, ease: Strong.easeInOut, delay:.6},.1)
			// this.tl.to(this.$refs.container,.1,{y:0, ease: Strong.easeInOut, delay:.6},.1)

		}
		

		_resize () {
			Globals.resize()
			this.$events.emit('app.resize')
			this.scroller.resize()
			this.$refs.bg._resize()

			let scrollHeight = this.$refs.container.getBoundingClientRect().height;

			this.tlBlock = new TimelineMax({paused: true})
			if(Globals.isLoaded) {
				
				this.tlBlock.fromTo(this.$container, 1,{y:0},{y:-scrollHeight, ease:Power0.easeNone},0)
			} else {
			// 	TweenMax.to(this.$refs.container,.1,{y:-window.innerHeight})
			}
			

			this.scroller.interval('landing', {
				start: 0, 
				end: scrollHeight,
				exec: (e) => { 
					this.tlBlock.progress(e.ratio) 
				}
			});

			// console.log(this.$events._events['app.loaded'].length)
		}

	}

	export default App

</script>


<style lang="stylus">
	
	@import 'theme/_theme'

	#container
		position relative
		height 100%
		width 100%
		top 0
		left 0
		overflow hidden

		.section
			position relative
			width 100%

			+break(xs)
				padding-left 30px
				padding-right 30px

	.story-page
		&:before, &:after
			display none !important
	
	.landing
		position absolute
		top 0
		left 0
		width 100vw
		height 100%
		overflow hidden

		.loader
			height 100%
			width 100%
			top -100vh
			left 0
			position fixed
			z-index 100

		.mask-wrapper
			position absolute
			top 0
			left 0
			right 0
			bottom 0
			z-index 70
			pointer-events none

			img
				object-fit cover
				height 100%
				width 100%
	
	.landing-container
		position absolute
		top 0
		left 0
		width 100%
		will-change transform
		min-height 100vh
		z-index 60
		transform-origin top center

		.desktop-version
			position relative
			width 100%



</style>


// WEBPACK FOOTER //
// app.vue?00eef8b8